export default __webpack_public_path__ + "static/media/chair-wood.33fe25e5.jpeg";